const availabilityParamName = 'filter.v.availability';
const availabilityHiddenSelector = 'input[type="hidden"][name="filter.v.availability"][value="1"]';
const availabilityCheckboxSelector = 'input[type="checkbox"][name="filter.v.availability"]';
const inStockSelector = `${availabilityCheckboxSelector}[value="1"]`;
const outOfStockSelector = `${availabilityCheckboxSelector}[value="0"]`;
const availabilityClearedKeyPrefix = 'collectionAvailabilityCleared:';
const availabilityLastSelectedKeyPrefix = 'collectionAvailabilityLastSelected:';

function getAvailabilityClearedKey(pathname = window.location.pathname) {
    return `${availabilityClearedKeyPrefix}${pathname}`;
}

function getAvailabilityLastSelectedKey(pathname = window.location.pathname) {
    return `${availabilityLastSelectedKeyPrefix}${pathname}`;
}

function setAvailabilityClearedState(isCleared, pathname = window.location.pathname) {
    try {
        if (isCleared) {
            window.sessionStorage.setItem(getAvailabilityClearedKey(pathname), '1');
            return;
        }

        window.sessionStorage.removeItem(getAvailabilityClearedKey(pathname));
    } catch (error) {
        // Ignore storage access restrictions.
    }
}

function setAvailabilityLastSelectedState(value, pathname = window.location.pathname) {
    try {
        if (value === '0' || value === '1') {
            window.sessionStorage.setItem(getAvailabilityLastSelectedKey(pathname), value);
            return;
        }

        window.sessionStorage.removeItem(getAvailabilityLastSelectedKey(pathname));
    } catch (error) {
        // Ignore storage access restrictions.
    }
}

function getAvailabilityClearedState(pathname = window.location.pathname) {
    try {
        return window.sessionStorage.getItem(getAvailabilityClearedKey(pathname)) === '1';
    } catch (error) {
        return false;
    }
}

function getAvailabilityLastSelectedState(pathname = window.location.pathname) {
    try {
        const value = window.sessionStorage.getItem(getAvailabilityLastSelectedKey(pathname));
        return value === '0' || value === '1' ? value : null;
    } catch (error) {
        return null;
    }
}

function normalizeAvailabilityFiltersInUrl() {
    if (!window.location || !window.location.href) return;

    const url = new URL(window.location.href);
    const availabilityValues = url.searchParams.getAll(availabilityParamName);
    const hasInStock = availabilityValues.includes('1');
    const hasOutOfStock = availabilityValues.includes('0');

    if (hasInStock && hasOutOfStock) {
        const lastSelectedAvailability = getAvailabilityLastSelectedState(url.pathname);
        const normalizedAvailability = lastSelectedAvailability === '1' || lastSelectedAvailability === '0' ? lastSelectedAvailability : '0';
        url.searchParams.delete(availabilityParamName);
        url.searchParams.append(availabilityParamName, normalizedAvailability);
        window.location.replace(url.toString());
        return;
    }

    if (hasInStock || hasOutOfStock) {
        setAvailabilityClearedState(false, url.pathname);
        setAvailabilityLastSelectedState(hasOutOfStock ? '0' : '1', url.pathname);
    }
}

function syncAvailabilityInputs(filterForm) {
    if (!filterForm) return;

    const hiddenDefaultInput = filterForm.querySelector(availabilityHiddenSelector);
    const inStockCheckbox = filterForm.querySelector(inStockSelector);
    const outOfStockCheckbox = filterForm.querySelector(outOfStockSelector);

    if (outOfStockCheckbox && outOfStockCheckbox.checked && inStockCheckbox) {
        inStockCheckbox.checked = false;
    }

    if (!hiddenDefaultInput) return;

    const hasOutOfStockChecked = Boolean(outOfStockCheckbox && outOfStockCheckbox.checked);
    const hasInStockChecked = Boolean(inStockCheckbox && inStockCheckbox.checked);
    hiddenDefaultInput.disabled = hasOutOfStockChecked || hasInStockChecked;
}

normalizeAvailabilityFiltersInUrl();

document.addEventListener('DOMContentLoaded', function() {
    const availabilityForm = document.querySelector('#qf-filter-wrapper .filter-container');
    if (availabilityForm) {
        syncAvailabilityInputs(availabilityForm);

        availabilityForm.addEventListener('change', (event) => {
            if (!event.target || !event.target.matches(availabilityCheckboxSelector)) return;

            const inStockCheckbox = availabilityForm.querySelector(inStockSelector);
            const outOfStockCheckbox = availabilityForm.querySelector(outOfStockSelector);

            if (event.target.checked) {
                if (event.target.value === '0' && inStockCheckbox) {
                    inStockCheckbox.checked = false;
                }

                if (event.target.value === '1' && outOfStockCheckbox) {
                    outOfStockCheckbox.checked = false;
                }
            }

            syncAvailabilityInputs(availabilityForm);
        });

        availabilityForm.addEventListener('submit', () => {
            syncAvailabilityInputs(availabilityForm);
        });

        availabilityForm.addEventListener('change', (event) => {
            if (!event.target || !event.target.matches(availabilityCheckboxSelector)) return;
            setAvailabilityClearedState(false);
            if (event.target.checked) {
                setAvailabilityLastSelectedState(event.target.value);
            }
        });

        document.addEventListener('click', (event) => {
            if (!(event.target instanceof Element)) return;

            const selectedFilterLink = event.target.closest('.selected-filter-wrapper a.selected-filter[href]');
            if (!selectedFilterLink) return;

            let nextUrl;
            let currentUrl;
            try {
                nextUrl = new URL(selectedFilterLink.href, window.location.origin);
                currentUrl = new URL(window.location.href);
            } catch (error) {
                return;
            }

            const currentAvailability = currentUrl.searchParams.getAll(availabilityParamName);
            const nextAvailability = nextUrl.searchParams.getAll(availabilityParamName);
            const hasCurrentAvailability = currentAvailability.includes('0') || currentAvailability.includes('1');
            const hasNextAvailability = nextAvailability.includes('0') || nextAvailability.includes('1');

            if (hasCurrentAvailability && !hasNextAvailability) {
                setAvailabilityClearedState(true, nextUrl.pathname);
            }
        }, true);
    }

    // Load more products

    const load_btn = document.querySelector(".custom-filter-load-more");

    let products_on_page = document.querySelector('.collection-grid');

    let url = products_on_page ? products_on_page.getAttribute('data-next-url') : '';

    const spinner = document.querySelector('.custom-filter-load-more .load-more-spinner');

    if (load_btn) {
        if (url === '') {
            load_btn.style.display = 'none';
        }

        load_btn.addEventListener("click", () => {

            console.log('clicked');

            spinner.classList.add("show");

            fetch(url)
                .then(function (response) {
                    if (response.ok) {
                        return response.text();
                    } else {
                        throw new Error('Network response was not ok.');
                    }
                })
                .then(function (data) {
                    const html = document.createElement('div');
                    html.innerHTML = data;

                    let links = html.querySelector('.pagination-links').innerHTML;
                    document.querySelector('.pagination-links').innerHTML = links;

                    let new_grid = html.querySelector('.collection-grid');
                    url = new_grid.getAttribute('data-next-url');
                    if (url === '') {
                        load_btn.style.display = 'none';
                    }
                    let new_products = new_grid.querySelectorAll(".product-card, .collection-grid-cta");

                    new_products.forEach(new_prod => {
                        products_on_page.append(new_prod);
                    });
                    spinner.classList.remove("show");
                })
                .catch(function (error) {
                    window.log(error);
                });
        })
    }

    loadFilterClicks();
    loadFilterBody();

    const rangeInputAll = document.querySelectorAll(".range-input input");
    const PRICE_TICK_STEPS = [10, 20, 25, 50, 100, 200, 250, 500, 1000];

    const parsePriceInt = (value, fallback = NaN) => {
        const parsed = parseInt(value, 10);
        return Number.isNaN(parsed) ? fallback : parsed;
    };

    const getPriceTickStep = (min, max) => {
        if (!Number.isFinite(min) || !Number.isFinite(max)) return 20;

        const range = Math.max(1, max - min);
        const targetStep = Math.max(10, range / 4);
        const matchedStep = PRICE_TICK_STEPS.find((step) => targetStep <= step);
        return matchedStep || PRICE_TICK_STEPS[PRICE_TICK_STEPS.length - 1];
    };

    const normalizePriceBounds = (min, max, step = getPriceTickStep(min, max)) => {
        if (!Number.isFinite(min) || !Number.isFinite(max)) return { min, max };
        let normalizedMin = Math.floor(min / step) * step;
        let normalizedMax = Math.ceil(max / step) * step;

        if (normalizedMax <= normalizedMin) {
            normalizedMax = normalizedMin + step;
        }

        return { min: normalizedMin, max: normalizedMax };
    };

    function updateTicksForContainer(container, bounds) {
        if (!container || !bounds) return;
        const min = parsePriceInt(bounds.min, NaN);
        const max = parsePriceInt(bounds.max, NaN);
        if (!Number.isFinite(min) || !Number.isFinite(max)) return;

        const tickStep = getPriceTickStep(min, max);
        const normalized = normalizePriceBounds(min, max, tickStep);
        const ticksContainer = container.querySelector('.ticks');
        if (!ticksContainer) return;

        const currencySymbolNode = container.querySelector('.price-input .field span');
        const currencySymbol = currencySymbolNode ? currencySymbolNode.textContent.trim() : '';
        const values = [];
        for (let value = normalized.min; value <= normalized.max; value += tickStep) {
            values.push(value);
        }

        if (values.length === 0 || values[values.length - 1] !== normalized.max) {
            values.push(normalized.max);
        }

        ticksContainer.innerHTML = '';
        values.forEach((value, idx) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'tick';
            button.setAttribute('data-value', String(value));

            const percent = values.length <= 1 ? 0 : (idx / (values.length - 1)) * 100;
            button.style.position = 'absolute';
            button.style.left = `${percent}%`;
            button.style.top = '50%';
            button.style.transform = 'translate(-50%,-50%)';
            button.style.pointerEvents = 'auto';
            button.style.background = 'transparent';
            button.style.border = 'none';

            button.innerHTML = `<span class="tick-dot" style="display:block;width:2px;height:12px;background:#cfcfcf;margin:0 auto;"></span><span class="tick-label" style="display:block;margin-top:6px;font-size:12px;color:#333;">${currencySymbol}${value}</span>`;
            ticksContainer.appendChild(button);
        });
    }

    function setPriceFilterSubmissionState(container, minVal, maxVal) {
        if (!container) return;
        const minFilter = container.querySelector('.min-price-filter');
        const maxFilter = container.querySelector('.max-price-filter');
        if (!minFilter || !maxFilter) return;

        const defaultMin = parsePriceInt(container.dataset.defaultMin, parsePriceInt(container.dataset.min, 0));
        const defaultMax = parsePriceInt(container.dataset.defaultMax, parsePriceInt(container.dataset.max, 0));
        const nextMin = parsePriceInt(minVal, defaultMin);
        const nextMax = parsePriceInt(maxVal, defaultMax);
        const isDirty = nextMin !== defaultMin || nextMax !== defaultMax;

        container.dataset.priceDirty = isDirty ? 'true' : 'false';
        if (isDirty) {
            minFilter.disabled = false;
            maxFilter.disabled = false;
            minFilter.value = String(nextMin);
            maxFilter.value = String(nextMax);
            return;
        }

        minFilter.value = '';
        maxFilter.value = '';
        minFilter.disabled = true;
        maxFilter.disabled = true;
    }

    function syncAllPriceFilterSubmissionStates() {
        document.querySelectorAll('.custom-range').forEach(container => {
            const rangeInputs = container.querySelectorAll('.range-input input');
            if (!rangeInputs || rangeInputs.length < 2) return;
            const defaultMin = parsePriceInt(container.dataset.defaultMin, parsePriceInt(rangeInputs[0].min, 0));
            const defaultMax = parsePriceInt(container.dataset.defaultMax, parsePriceInt(rangeInputs[1].max, 0));
            const minVal = parsePriceInt(rangeInputs[0].value, defaultMin);
            const maxVal = parsePriceInt(rangeInputs[1].value, defaultMax);
            setPriceFilterSubmissionState(container, minVal, maxVal);
        });
    }
    function initializePriceRangeSlider() {
        if (rangeInputAll.length === 0) return;
        // Initialize each custom-range independently
        document.querySelectorAll('.custom-range').forEach(container => {
            const localRangeInputs = container.querySelectorAll('.range-input input');
            if (!localRangeInputs || localRangeInputs.length < 2) return;

            const localPriceInputs = container.querySelectorAll('.price-input-show');
            const localProgress = container.querySelector('.slider .progress');
            const localMinFilter = container.querySelector('.min-price-filter');
            const localMaxFilter = container.querySelector('.max-price-filter');
            const lockBounds = container.dataset.lockBounds === 'true';
            const boundsStorageKey = `priceBounds:${window.location.pathname}`;
            let priceGap = 1;
            // Track which handle the user last interacted with (used for tick selection)
            let lastActive = 'max';

            // Helpers to read/write price displays that may be either DIVs or INPUTs
            const getPriceValue = (el) => {
                if (!el) return NaN;

                const tag = el.tagName ? el.tagName.toUpperCase() : '';
                if (tag === 'INPUT' || tag === 'TEXTAREA') {
                    const raw = el.value;
                    if (raw === '' || raw === null || raw === undefined) return NaN;
                    const parsed = parseInt(raw, 10);
                    return Number.isNaN(parsed) ? NaN : parsed;
                }

                const parsed = parseInt(el.innerHTML, 10);
                return Number.isNaN(parsed) ? NaN : parsed;
            };

            const setPriceValue = (el, val) => {
                if (!el) return;

                const tag = el.tagName ? el.tagName.toUpperCase() : '';
                if (tag === 'INPUT' || tag === 'TEXTAREA') {
                    el.value = val;
                } else {
                    el.innerHTML = val;
                }
            };

            const parseIntSafe = (value, fallback = NaN) => {
                const parsed = parseInt(value, 10);
                return Number.isNaN(parsed) ? fallback : parsed;
            };

            const clamp = (num, min, max) => Math.min(max, Math.max(min, num));

            const readStoredBounds = () => {
                if (!lockBounds) return null;
                try {
                    const raw = sessionStorage.getItem(boundsStorageKey);
                    if (!raw) return null;
                    const parsed = JSON.parse(raw);
                    if (!Number.isFinite(parsed?.min) || !Number.isFinite(parsed?.max)) return null;
                    return parsed;
                } catch (err) {
                    return null;
                }
            };

            const writeStoredBounds = (bounds) => {
                if (!lockBounds) return;
                try {
                    sessionStorage.setItem(boundsStorageKey, JSON.stringify(bounds));
                } catch (err) {
                    // ignore storage failures
                }
            };

            const syncInputBounds = (bounds) => {
                if (!lockBounds || !bounds) return;
                const { min, max } = bounds;

                localRangeInputs.forEach(input => {
                    input.min = String(min);
                    input.max = String(max);
                    input.dataset.min = String(min);
                    input.dataset.max = String(max);
                });

                if (localPriceInputs && localPriceInputs.length >= 2) {
                    localPriceInputs[0].min = String(min);
                    localPriceInputs[0].max = String(max);
                    localPriceInputs[1].min = String(min);
                    localPriceInputs[1].max = String(max);
                }

                if (localMinFilter) {
                    localMinFilter.min = String(min);
                    localMinFilter.max = String(max);
                    localMinFilter.placeholder = String(min);
                }
                if (localMaxFilter) {
                    localMaxFilter.min = String(min);
                    localMaxFilter.max = String(max);
                    localMaxFilter.placeholder = String(max);
                }
            };

            const getBounds = () => {
                const boundMin = Number.isFinite(Number(container?.dataset?.min))
                    ? Number(container.dataset.min)
                    : parseIntSafe(localRangeInputs[0].min, 0);

                const boundMax = Number.isFinite(Number(container?.dataset?.max))
                    ? Number(container.dataset.max)
                    : parseIntSafe(localRangeInputs[1].max, 0);

                let min = Math.min(boundMin, boundMax);
                let max = Math.max(boundMin, boundMax);

                const normalizedBounds = normalizePriceBounds(min, max);
                min = normalizedBounds.min;
                max = normalizedBounds.max;

                if (lockBounds) {
                    const stored = readStoredBounds();
                    if (stored) {
                        const normalizedStored = normalizePriceBounds(stored.min, stored.max);
                        min = normalizedStored.min;
                        max = normalizedStored.max;
                    } else {
                        writeStoredBounds({ min, max });
                    }
                    syncInputBounds({ min, max });
                }
                const range = Math.max(1, max - min);

                return { min, max, range };
            };

            const updateProgress = (minVal, maxVal) => {
                if (!localProgress) return;

                const { min, range } = getBounds();
                const minPercent = clamp(((minVal - min) / range) * 100, 0, 100);
                const maxPercent = clamp(((maxVal - min) / range) * 100, 0, 100);

                // Preferred robust approach: left + right prevents overflow beyond the track
                localProgress.style.left = `${minPercent}%`;
                localProgress.style.right = `${100 - maxPercent}%`;
                // Ensure legacy width-based styles don't fight with right-based positioning
                localProgress.style.width = '';
            };

            const applyValues = ({ minVal, maxVal, source = 'init' }) => {
                const { min, max } = getBounds();

                let nextMin = clamp(parseIntSafe(minVal, min), min, max);
                let nextMax = clamp(parseIntSafe(maxVal, max), min, max);

                if ((nextMax - nextMin) < priceGap) {
                    if (source === 'min') {
                        nextMin = nextMax - priceGap;
                    } else if (source === 'max') {
                        nextMax = nextMin + priceGap;
                    } else {
                        // init/tick: try to expand max first, otherwise shift min
                        if (nextMin + priceGap <= max) nextMax = nextMin + priceGap;
                        else nextMin = nextMax - priceGap;
                    }
                }

                nextMin = clamp(nextMin, min, max);
                nextMax = clamp(nextMax, min, max);

                // Write back to range inputs
                localRangeInputs[0].value = nextMin;
                localRangeInputs[0].setAttribute("data-term", nextMin);
                localRangeInputs[1].value = nextMax;

                // Write back to visible inputs (can be INPUTs or DIVs depending on template)
                if (localPriceInputs && localPriceInputs.length >= 2) {
                    setPriceValue(localPriceInputs[0], nextMin);
                    setPriceValue(localPriceInputs[1], nextMax);
                }

                // Hidden filter inputs only when user intentionally changed range
                setPriceFilterSubmissionState(container, nextMin, nextMax);

                // Progress bar
                updateProgress(nextMin, nextMax);
            };

            // Determine initial values (prefer hidden filter inputs when present)
            const { min: boundMin, max: boundMax } = getBounds();
            const hasMinFilterVal = localMinFilter && localMinFilter.value !== '';
            const hasMaxFilterVal = localMaxFilter && localMaxFilter.value !== '';
            const initialMin = hasMinFilterVal
                ? parseIntSafe(localMinFilter.value, boundMin)
                : parseIntSafe(localRangeInputs[0].value, boundMin);
            const initialMax = hasMaxFilterVal
                ? parseIntSafe(localMaxFilter.value, boundMax)
                : parseIntSafe(localRangeInputs[1].value, boundMax);

            // Initialize all UI state in one place (ranges, visible inputs, hidden filters, progress)
            applyValues({ minVal: initialMin, maxVal: initialMax, source: 'init' });
            container.dataset.defaultMin = String(boundMin);
            container.dataset.defaultMax = String(boundMax);
            setPriceFilterSubmissionState(container, initialMin, initialMax);
            updateTicksForContainer(container, { min: boundMin, max: boundMax });

            // ---- Normalize ticks: ensure progress is visible and ticks are clickable ----
            const currentTicks = container.querySelectorAll('.ticks .tick');
            if (currentTicks && currentTicks.length > 0) {
                // ensure progress is visible (fallback color) and stacked under ticks
                if (localProgress) {
                    const computedBg = getComputedStyle(localProgress).backgroundColor;
                    if (!computedBg || computedBg === 'rgba(0, 0, 0, 0)' || computedBg === 'transparent') {
                        // a subtle green-ish fallback that matches theme styles in the repo
                        localProgress.style.backgroundColor = '#cfead0';
                    }
                    localProgress.style.zIndex = '1';
                }

                const ticksContainer = container.querySelector('.ticks');
                if (ticksContainer) {
                    ticksContainer.style.zIndex = '2';
                    // keep the container non-blocking except for the buttons
                    ticksContainer.style.pointerEvents = 'none';
                    // ensure buttons can receive pointer events
                    ticksContainer.querySelectorAll('button.tick').forEach(btn => btn.style.pointerEvents = 'auto');
                }

                // Tick click: move the last-active handle to the tick value, then re-apply constraints and refresh UI
                currentTicks.forEach((tick) => {
                    tick.addEventListener('click', () => {
                        const tickValue = parseIntSafe(tick.dataset.value, NaN);
                        if (!Number.isFinite(tickValue)) return;

                        const { min, max } = getBounds();
                        const currentMin = parseIntSafe(localRangeInputs[0].value, min);
                        const currentMax = parseIntSafe(localRangeInputs[1].value, max);

                        // Default to moving the handle the user last interacted with.
                        // If unknown, choose the closer handle.
                        let source = lastActive;
                        if (source !== 'min' && source !== 'max') {
                            const dMin = Math.abs(tickValue - currentMin);
                            const dMax = Math.abs(tickValue - currentMax);
                            source = dMin <= dMax ? 'min' : 'max';
                        }

                        const nextMin = source === 'min' ? tickValue : currentMin;
                        const nextMax = source === 'max' ? tickValue : currentMax;

                        applyValues({ minVal: nextMin, maxVal: nextMax, source });
                    });
                });
            }
            // ---- end normalize ticks ----

            // Visible price inputs -> update ranges, hidden inputs, and progress
            if (localPriceInputs && localPriceInputs.length >= 2) {
                localPriceInputs.forEach((el) => {
                    el.addEventListener('focus', () => {
                        if (el.classList.contains('input-min')) lastActive = 'min';
                        if (el.classList.contains('input-max')) lastActive = 'max';
                    });

                    el.addEventListener("input", (e) => {
                        const source = e.target.classList.contains("input-min") ? 'min' : 'max';
                        lastActive = source;

                        const { min, max } = getBounds();
                        const currentMin = parseIntSafe(localRangeInputs[0].value, min);
                        const currentMax = parseIntSafe(localRangeInputs[1].value, max);

                        const typedMin = getPriceValue(localPriceInputs[0]);
                        const typedMax = getPriceValue(localPriceInputs[1]);

                        const rawValue = e.target.value;
                        const isWithinBounds = (val) => Number.isFinite(val) && val >= min && val <= max;

                        // Allow clearing/partial typing without snapping back to bounds.
                        if (rawValue === '' || rawValue === null || rawValue === undefined) return;
                        if (source === 'min' && !isWithinBounds(typedMin)) return;
                        if (source === 'max' && !isWithinBounds(typedMax)) return;

                        // If a field is temporarily empty/invalid while typing, keep the current slider value
                        const nextMin = Number.isFinite(typedMin) ? typedMin : currentMin;
                        const nextMax = Number.isFinite(typedMax) ? typedMax : currentMax;

                        applyValues({ minVal: nextMin, maxVal: nextMax, source });
                    });

                    // On change, clamp into bounds and re-render (prevents out-of-range typed values from persisting)
                    el.addEventListener("change", (e) => {
                        const source = e.target.classList.contains("input-min") ? 'min' : 'max';
                        lastActive = source;

                        const { min, max } = getBounds();
                        const currentMin = parseIntSafe(localRangeInputs[0].value, min);
                        const currentMax = parseIntSafe(localRangeInputs[1].value, max);

                        const typedMin = getPriceValue(localPriceInputs[0]);
                        const typedMax = getPriceValue(localPriceInputs[1]);

                        const nextMin = Number.isFinite(typedMin) ? typedMin : currentMin;
                        const nextMax = Number.isFinite(typedMax) ? typedMax : currentMax;

                        applyValues({ minVal: nextMin, maxVal: nextMax, source });
                    });
                });

            }

            // Range inputs -> update visible prices, hidden inputs, and progress
            localRangeInputs.forEach((input) => {
                input.addEventListener("input", (e) => {
                    const source = e.target.classList.contains("range-min") ? 'min' : 'max';
                    lastActive = source;

                    const { min, max } = getBounds();
                    const minVal = parseIntSafe(localRangeInputs[0].value, min);
                    const maxVal = parseIntSafe(localRangeInputs[1].value, max);

                    applyValues({ minVal, maxVal, source });
                });
            });
        });
    }
    initializePriceRangeSlider();
    (function syncPriceBoundsFromGrid() {
        const bounds = getPriceBoundsFromScope(document);
        const priceFilter = document.querySelector('.price-filter-container');
        if (!bounds || !priceFilter) return;
        const rangeContainer = priceFilter.querySelector('.custom-range');
        if (rangeContainer && rangeContainer.dataset.lockBounds === 'true') return;
        applyPriceBoundsToContainer(priceFilter, bounds);
        initializePriceRangeSlider();
    })();

    // Availability: no longer force a default URL param; rely solely on
    // the user's explicit filter selections via the filter form.

    function replaceCollectionGridFromDocument(doc) {
        if (!doc) return false;

        const nextGrid = doc.querySelector('.collection-grid');
        const currentGrid = document.querySelector('.collection-grid');
        if (!nextGrid || !currentGrid) return false;

        currentGrid.replaceWith(nextGrid);
        products_on_page = document.querySelector('.collection-grid');
        collection_grid = products_on_page;
        url = products_on_page ? (products_on_page.getAttribute('data-next-url') || '') : '';

        const currentPaginationLinks = document.querySelector('.pagination-links');
        const nextPaginationLinks = doc.querySelector('.pagination-links');
        if (currentPaginationLinks && nextPaginationLinks) {
            currentPaginationLinks.innerHTML = nextPaginationLinks.innerHTML;
        }

        if (load_btn) {
            load_btn.style.display = url === '' ? 'none' : '';
        }

        return true;
    }

    function closeMobileFilterDrawer() {
        if (window.innerWidth > 768) return;
        if (mobile_control) mobile_control.classList.remove('open');
        if (filter_body) filter_body.classList.remove('open');
    }

    function refreshFilterContainerFromUrl(fullUrl, currentOpen = null) {
        const filter_form = document.querySelector('.filter-container');
        if (!filter_form) return Promise.resolve(false);

        return fetch(fullUrl)
            .then((res) => {
                if (!res.ok) throw new Error('filter refresh failed');
                return res.text();
            })
            .then((html) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');

                const newFilters = doc.querySelector('.filter-container');
                if (!newFilters) return false;
                filter_form.innerHTML = newFilters.innerHTML;

                if (currentOpen) {
                    const reopened = document.querySelector('.custom-filter[data-order="' + currentOpen + '"]');
                    if (reopened) {
                        reopened.classList.add('open');
                    }
                }

                replaceCollectionGridFromDocument(doc);
                window.history.replaceState({}, '', fullUrl);
                loadFilterClicks();
                loadFilterBody();
                initializePriceRangeSlider();
                bindPriceApplyButtons();
                decorateLinksWithAvailability(document);
                closeMobileFilterDrawer();
                return true;
            })
            .catch((error) => {
                console.warn('Unable to refresh collection filters', error);
                return false;
            });
    }

    function getPriceBoundsFromScope(scope) {
        if (!scope) return null;
        const priceNodes = scope.querySelectorAll('.collection-grid .product-price[data-price]');
        if (!priceNodes || priceNodes.length === 0) return null;

        let minCents = Infinity;
        let maxCents = -Infinity;

        priceNodes.forEach(node => {
            const raw = node.getAttribute('data-price');
            const parsed = parseInt(raw, 10);
            if (Number.isNaN(parsed)) return;
            if (parsed < minCents) minCents = parsed;
            if (parsed > maxCents) maxCents = parsed;
        });

        if (!Number.isFinite(minCents) || !Number.isFinite(maxCents)) return null;

        const min = Math.floor(minCents / 100);
        const max = Math.ceil(maxCents / 100);
        return { min, max };
    }
    function applyPriceBoundsToContainer(priceFilterEl, bounds) {
        if (!priceFilterEl || !bounds) return;

        const rangeContainer = priceFilterEl.querySelector('.custom-range');
        if (!rangeContainer) return;
        if (rangeContainer.dataset.lockBounds === 'true') return;

        const normalizedBounds = normalizePriceBounds(bounds.min, bounds.max);
        const minVal = normalizedBounds.min;
        const maxVal = normalizedBounds.max;

        rangeContainer.dataset.min = String(minVal);
        rangeContainer.dataset.max = String(maxVal);

        const rangeInputs = rangeContainer.querySelectorAll('.range-input input');
        rangeInputs.forEach(input => {
            input.min = String(minVal);
            input.max = String(maxVal);
            input.dataset.min = String(minVal);
            input.dataset.max = String(maxVal);
        });

        const minFilter = rangeContainer.querySelector('.min-price-filter');
        const maxFilter = rangeContainer.querySelector('.max-price-filter');
        const rawMinFilterVal = minFilter ? parseInt(minFilter.value, 10) : NaN;
        const rawMaxFilterVal = maxFilter ? parseInt(maxFilter.value, 10) : NaN;
        const hasMinFilterVal = Number.isFinite(rawMinFilterVal);
        const hasMaxFilterVal = Number.isFinite(rawMaxFilterVal);
        const activeMinVal = hasMinFilterVal ? Math.min(Math.max(rawMinFilterVal, minVal), maxVal) : minVal;
        const activeMaxVal = hasMaxFilterVal ? Math.min(Math.max(rawMaxFilterVal, minVal), maxVal) : maxVal;

        if (minFilter) {
            minFilter.min = String(minVal);
            minFilter.max = String(maxVal);
            minFilter.placeholder = String(minVal);
            if (hasMinFilterVal) minFilter.value = String(activeMinVal);
        }
        if (maxFilter) {
            maxFilter.min = String(minVal);
            maxFilter.max = String(maxVal);
            maxFilter.placeholder = String(maxVal);
            if (hasMaxFilterVal) maxFilter.value = String(activeMaxVal);
        }

        const visibleMin = rangeContainer.querySelector('.price-input-show.input-min');
        const visibleMax = rangeContainer.querySelector('.price-input-show.input-max');
        if (visibleMin) {
            visibleMin.min = String(minVal);
            visibleMin.max = String(maxVal);
            if (!hasMinFilterVal) visibleMin.value = String(activeMinVal);
        }
        if (visibleMax) {
            visibleMax.min = String(minVal);
            visibleMax.max = String(maxVal);
            if (!hasMaxFilterVal) visibleMax.value = String(activeMaxVal);
        }

        if (rangeInputs && rangeInputs.length >= 2) {
            rangeInputs[0].value = String(activeMinVal);
            rangeInputs[1].value = String(activeMaxVal);
            rangeInputs[0].setAttribute('data-term', String(activeMinVal));
            rangeInputs[1].setAttribute('data-term', String(activeMaxVal));
        }

        updateTicksForContainer(rangeContainer, { min: minVal, max: maxVal });
        rangeContainer.dataset.defaultMin = String(minVal);
        rangeContainer.dataset.defaultMax = String(maxVal);
        setPriceFilterSubmissionState(rangeContainer, activeMinVal, activeMaxVal);
    }
    function refreshPriceFilter(fullUrl) {
        const currentPriceFilter = document.querySelector('.price-filter-container');
        if (!currentPriceFilter) return Promise.resolve(false);

        const wasOpen = currentPriceFilter.classList.contains('open');

        return fetch(fullUrl, { credentials: 'same-origin' })
            .then(res => {
                if (!res.ok) throw new Error('price filter fetch failed');
                return res.text();
            })
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newPriceFilter = doc.querySelector('.price-filter-container');
                if (!newPriceFilter) return false;

                const bounds = getPriceBoundsFromScope(doc);
                const rangeContainer = newPriceFilter.querySelector('.custom-range');
                const lockBounds = rangeContainer && rangeContainer.dataset.lockBounds === 'true';
                if (bounds && !lockBounds) {
                    applyPriceBoundsToContainer(newPriceFilter, bounds);
                }

                currentPriceFilter.replaceWith(newPriceFilter);
                if (wasOpen) newPriceFilter.classList.add('open');

                loadFilterBody();
                initializePriceRangeSlider();
                bindPriceApplyButtons();
                return true;
            })
            .catch(err => {
                console.warn('Unable to refresh price filter', err);
                return false;
            });
    }
    function loadFilterBody() {
        let custom_filters = document.querySelectorAll(".custom-filter")

        custom_filters.forEach((el) => {
            if (el.dataset.filterBound === 'true') return;

            let control = el.querySelector(".filter-heading")
            let body = el.querySelector(".filter-body")

            if (control && body) {

                control.addEventListener('click', () => {

                    if (el.classList.contains("open")) {
                        el.classList.remove("open")
                    } else {
                        custom_filters.forEach(f => f.classList.remove("open"))
                        el.classList.add("open")
                    }

                })
                el.dataset.filterBound = 'true';
            }
        })
    }

    let mobile_control = document.querySelector(".mobile-filter-heading")
    let filter_body = document.querySelector(".custom-filter-wrapper")

    if (mobile_control && filter_body) {
        mobile_control.addEventListener('click', () => {
            console.log("CLICK")
            // rotate svg
            if (mobile_control.classList.contains("open")) {
                mobile_control.classList.remove("open")
            } else {
                mobile_control.classList.add("open")
            }

            // open filters
            if (filter_body.classList.contains("open")) {
                filter_body.classList.remove("open")
            } else {
                filter_body.classList.add("open")
            }
        })
    }

    // Hide reset filters when no filters active
    const reset_filters = document.querySelector('.reset-filter-wrapper');
    const selected_filters_html = document.querySelectorAll('.selected-filter-wrapper *');
    let collection_grid = document.querySelector('.collection-grid');

    if (reset_filters && selected_filters_html.length > 0) {
        reset_filters.style.display = 'block';
    }

    // When clicking "selected filters" links, show loading state for the impending navigation
    selected_filters_html.forEach(selected => {
        selected.addEventListener('click', () => {
            if (collection_grid) collection_grid.classList.add("loading");
        });
    });

    // Desktop: always auto-apply filters on change.
    // The "Apply filters" CTA is mobile-only.
    if (window.innerWidth >= 769) {
        const filter_inputs = document.querySelectorAll('.filter-container-wrapper select, .filter-container-wrapper input');
        const filter_form = document.querySelector('.filter-container');

        const isIgnorableInput = (input) => {
            if (!input) return true;
            if (input.hasAttribute && input.hasAttribute('data-default-availability-filter')) return true;
            return false;
        };

        if (filter_form && filter_inputs) {
            filter_inputs.forEach(input => {
                if (isIgnorableInput(input)) return;
                input.addEventListener('change', () => {
                    if (input.closest('.price-filter-container')) return;
                    syncAllPriceFilterSubmissionStates();
                    if (collection_grid) collection_grid.classList.add("loading");
                    filter_form.submit();
                });
            });
        }
    }

    function bindPriceApplyButtons() {
        const applyButtons = document.querySelectorAll('.price-filter-apply');
        const filter_form = document.querySelector('.filter-container');
        if (!applyButtons || !filter_form) return;

        applyButtons.forEach(button => {
            if (button.dataset.bound === 'true') return;
            button.dataset.bound = 'true';
            button.addEventListener('click', () => {
                syncAllPriceFilterSubmissionStates();
                const formData = new FormData(filter_form);
                const params = new URLSearchParams(formData);
                const collectionUrl = window.location.pathname;
                const fullUrl = `${collectionUrl}?${params.toString()}`;
                const currentOpen = document.querySelector('.custom-filter.open')?.getAttribute('data-order');

                if (window.innerWidth >= 769) {
                    if (collection_grid) collection_grid.classList.add("loading");
                    filter_form.submit();
                    return;
                }

                refreshFilterContainerFromUrl(fullUrl, currentOpen);
            });
        });
    }

    function updateMobileSelectedFilterPreview() {
        if (window.innerWidth > 768) return;

        const filterForm = document.querySelector('.filter-container');
        const wrapper = document.querySelector('.selected-filter-wrapper');
        if (!filterForm || !wrapper) return;

        const chips = [];
        const seen = new Set();

        const cleanText = (value) => (value || '').replace(/\s+/g, ' ').trim();
        const stripCountSuffix = (value) => cleanText(value).replace(/\s*\(\d+\)\s*$/, '');

        const checkedInputs = filterForm.querySelectorAll('.filter-body input[type="checkbox"]:checked');
        checkedInputs.forEach((input) => {
            const label = input.closest('label');
            const filter = input.closest('.custom-filter');
            if (!label || !filter) return;

            const filterHeading = stripCountSuffix(filter.querySelector('.filter-heading')?.childNodes?.[0]?.textContent || '');
            const optionLabel = stripCountSuffix(label.textContent || '');
            if (!optionLabel) return;

            const chipLabel = filterHeading ? `${filterHeading}: ${optionLabel}` : optionLabel;
            const dedupeKey = chipLabel.toLowerCase();
            if (seen.has(dedupeKey)) return;
            seen.add(dedupeKey);
            chips.push({
                action: 'toggle-checkbox',
                inputId: input.id,
                text: chipLabel
            });
        });

        const activeAvailabilityInput = filterForm.querySelector(`${availabilityCheckboxSelector}:checked`);
        if (activeAvailabilityInput) {
            const availabilityLabel = activeAvailabilityInput.closest('label');
            const availabilityText = stripCountSuffix(availabilityLabel?.textContent || '');
            const availabilityChip = availabilityText ? `Availability: ${availabilityText}` : 'Availability';
            const dedupeKey = availabilityChip.toLowerCase();
            if (!seen.has(dedupeKey)) {
                seen.add(dedupeKey);
                chips.push({
                    action: 'toggle-checkbox',
                    inputId: activeAvailabilityInput.id,
                    text: availabilityChip
                });
            }
        }

        const priceContainer = filterForm.querySelector('.custom-range');
        if (priceContainer && priceContainer.dataset.priceDirty === 'true') {
            const minInput = priceContainer.querySelector('.price-input-show.input-min');
            const maxInput = priceContainer.querySelector('.price-input-show.input-max');
            const minValue = parsePriceInt(minInput?.value, NaN);
            const maxValue = parsePriceInt(maxInput?.value, NaN);
            if (Number.isFinite(minValue) && Number.isFinite(maxValue)) {
                const priceChip = `£${minValue} - £${maxValue}`;
                if (!seen.has(priceChip.toLowerCase())) {
                    seen.add(priceChip.toLowerCase());
                    chips.push({
                        action: 'reset-price',
                        text: priceChip
                    });
                }
            }
        }

        wrapper.innerHTML = '';
        chips.forEach((chipData) => {
            const chip = document.createElement('button');
            const chipLabel = chipData.text || '';

            chip.type = 'button';
            chip.className = 'selected-filter';
            chip.dataset.mobileFilterAction = chipData.action;
            if (chipData.inputId) {
                chip.dataset.inputId = chipData.inputId;
            }
            chip.setAttribute('aria-label', `Remove ${chipLabel}`);
            chip.innerHTML = `<span aria-hidden="true">×</span>${chipLabel}`;
            wrapper.appendChild(chip);
        });

        if (wrapper.dataset.bound === 'true') return;

        wrapper.dataset.bound = 'true';
        wrapper.addEventListener('click', (event) => {
            const chip = event.target.closest('button.selected-filter[data-mobile-filter-action]');
            if (!chip) return;

            if (chip.dataset.mobileFilterAction === 'toggle-checkbox') {
                const inputId = chip.dataset.inputId;
                const input = inputId ? filterForm.querySelector(`#${CSS.escape(inputId)}`) : null;
                if (!input) return;
                input.checked = false;
                input.dispatchEvent(new Event('change', { bubbles: true }));
                return;
            }

            if (chip.dataset.mobileFilterAction === 'reset-price') {
                const priceFilterContainer = filterForm.querySelector('.custom-range');
                const rangeInputs = priceFilterContainer?.querySelectorAll('.range-input input');
                const minVisibleInput = priceFilterContainer?.querySelector('.price-input-show.input-min');
                const maxVisibleInput = priceFilterContainer?.querySelector('.price-input-show.input-max');
                const progress = priceFilterContainer?.querySelector('.slider .progress');
                if (!priceFilterContainer || !rangeInputs || rangeInputs.length < 2) return;

                const defaultMin = parsePriceInt(priceFilterContainer.dataset.defaultMin, parsePriceInt(rangeInputs[0].min, 0));
                const defaultMax = parsePriceInt(priceFilterContainer.dataset.defaultMax, parsePriceInt(rangeInputs[1].max, 0));

                rangeInputs[0].value = String(defaultMin);
                rangeInputs[1].value = String(defaultMax);
                rangeInputs[0].setAttribute('data-term', String(defaultMin));
                rangeInputs[1].setAttribute('data-term', String(defaultMax));

                if (minVisibleInput) minVisibleInput.value = String(defaultMin);
                if (maxVisibleInput) maxVisibleInput.value = String(defaultMax);

                if (progress) {
                    progress.style.left = '0%';
                    progress.style.right = '0%';
                    progress.style.width = '';
                }

                setPriceFilterSubmissionState(priceFilterContainer, defaultMin, defaultMax);
                updateMobileSelectedFilterPreview();
            }
        });
    }

    function loadFilterClicks() {
        if (window.innerWidth <= 768) {
            const filter_form = document.querySelector('.filter-container');
            const applyButton = document.querySelector('.mobile-apply-filters');
            if (!filter_form || !applyButton) return;

            if (filter_form.dataset.mobilePreviewBound !== 'true') {
                filter_form.dataset.mobilePreviewBound = 'true';
                const refreshPreview = () => {
                    syncAllPriceFilterSubmissionStates();
                    updateMobileSelectedFilterPreview();
                };

                filter_form.addEventListener('change', refreshPreview);
                filter_form.addEventListener('input', (event) => {
                    if (!(event.target instanceof Element)) return;
                    if (!event.target.closest('.price-filter-container')) return;
                    refreshPreview();
                });
            }

            updateMobileSelectedFilterPreview();
            if (applyButton.dataset.bound === 'true') return;

            applyButton.dataset.bound = 'true';
            applyButton.addEventListener('click', () => {
                syncAllPriceFilterSubmissionStates();

                const formData = new FormData(filter_form);
                const params = new URLSearchParams(formData);

                const collectionUrl = window.location.pathname;
                const fullUrl = `${collectionUrl}?${params.toString()}`;
                const currentOpen = document.querySelector('.custom-filter.open')?.getAttribute('data-order');

                if (collection_grid) collection_grid.classList.add("loading");
                refreshFilterContainerFromUrl(fullUrl, currentOpen).finally(() => {
                    collection_grid = document.querySelector('.collection-grid');
                    if (collection_grid) collection_grid.classList.remove("loading");
                });
            });
        }
    }

    // Add resize reload handler: reload page when crossing mobile/desktop breakpoint (<=768px)
    (function () {
        const BREAKPOINT = 768;
        let lastIsMobile = window.innerWidth <= BREAKPOINT;
        function debounce(fn, wait) {
            let t;
            return function (...args) {
                clearTimeout(t);
                t = setTimeout(function () { fn.apply(this, args); }, wait);
            };
        }
        const onResize = debounce(function () {
            const isMobile = window.innerWidth <= BREAKPOINT;
            if (isMobile !== lastIsMobile) {
                console.debug('Viewport crossed breakpoint; reloading page to reinitialize filter logic.');
                // Use location.reload() to refresh page and re-bind the proper listeners.
                window.location.reload();
            }
        }, 200);
        window.addEventListener('resize', onResize);
    })();

    bindPriceApplyButtons();
    syncAllPriceFilterSubmissionStates();
    decorateLinksWithAvailability(document);

});
